import { cx } from "@/utils";

import styles from "./StatusLegend.module.css";

export type StatusColor = "green" | "yellow" | "red" | "gray";
export type LegendSize = "large";

const StatusLegend: React.FunctionComponent<{
  color: StatusColor;
  size?: LegendSize;
}> = ({ color, size }) => {
  return (
    <div
      className={cx(styles.statusLegend, {
        [styles.green]: color === "green",
        [styles.yellow]: color === "yellow",
        [styles.red]: color === "red",
        [styles.gray]: color === "gray",
        [styles.large]: size === "large",
      })}
    ></div>
  );
};

export default StatusLegend;
